import { GetJobSeekerDetailsResponse, AddJobSeekerDetailsRequest, JobSeekerBasicDetails, JobSeekerQualificationDetails, JobSeekerExperienceDetails, JobSeekerPreferredLocationDetails, JobSeekerSkillDetails, skillLevel, User } from "../types/api";
import { UserProfileFormData } from "../types/components";
import { CityObj, SkillObj } from "../config/metadata";
import { mapApiCourseToQualification, mapLocation, mapLocations } from "./jobPostMapper";
import allSkills from "../config/allSkill.json";
import { LocalStorageUser } from "../types/localStorage";
// Function to map API response to UI form data
export const mapApiToFormData = (apiData: GetJobSeekerDetailsResponse | null, user: LocalStorageUser): UserProfileFormData => {
  const initialFormData: UserProfileFormData = {
    fullName: `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
    experienceType: undefined,
    expFile: null,
    preferredRole: "",
    currentCTC: "",
    emailOtp: "",
    experience: [],
    firstName: "",
    lastName: "",
    email: user.email || "",
    emailVerified : user.emailVerified,
    phone: user?.mobileNumber,
    dateOfBirth: user.dateOfBirth || "", // todo add dob in response
    gender: '',
    address: "",
    skills: [],
    jobTypes: [],
    workModes: [],
    currentState: "",
    currentCity: "",
    preferredLocations:[],
    qualifications: [],
    attachments:[]
  };

  if (!apiData) {
    return initialFormData;
  }
  const currentCity: CityObj | undefined = apiData.jobSeekerBasicDetails?.cityId ? mapLocation(apiData.jobSeekerBasicDetails?.cityId) : undefined;

  return {
    ...initialFormData,
    gender: apiData.jobSeekerBasicDetails?.gender || initialFormData.gender,
    address: apiData.jobSeekerBasicDetails?.address || initialFormData.address,
    currentState: currentCity ? currentCity.stateName : initialFormData.currentState,
    currentCity: currentCity ? `${String(currentCity.cityId)},${currentCity.cityName}` : initialFormData.currentCity,
    experienceType: apiData.jobSeekerExperienceDetails?.isFresher === true ? 'fresher' : (apiData.jobSeekerExperienceDetails?.yearsOfExperience ? 'experienced' : initialFormData.experienceType),
    currentCTC: apiData.jobSeekerExperienceDetails?.currentCTC,
    skills: apiData.jobSeekerSkillDetails ? mapApiToSelectedSkill(apiData.jobSeekerSkillDetails) : initialFormData.skills, // Assuming skillId can be used as string
    preferredLocations: apiData.jobSeekerPreferredLocationDetails ? apiData.jobSeekerPreferredLocationDetails.map(c => mapLocation(c.cityId)).filter(a => a != null).map((a) => a as CityObj) : [],
    attachments: apiData.attachments || []
  };
};

// Function to map UI form data to API request payload
export const mapFormDataToApi = (formData: UserProfileFormData, userId: string | undefined): AddJobSeekerDetailsRequest => {
  const request: AddJobSeekerDetailsRequest = {
    userId: userId,
  };

  if (formData.gender || formData.address || formData.currentCity) {
    request.jobSeekerBasicDetails = {
      gender: formData.gender == "" ? undefined : formData.gender,
      address: formData.address,
      cityId: formData.currentCity ? parseInt(formData.currentCity) : undefined,
    };
  }


  if (formData.experienceType) {
    request.jobSeekerExperienceDetails = {
      isFresher: formData.experienceType === 'fresher',
      yearsOfExperience: formData.experienceType === 'experienced' && formData.experience?.length ? parseInt(formData.experience[0].salary || '0') : undefined, // Assuming salary stores years of experience
      currentCTC: formData.currentCTC
    };
  }

  if (formData.skills && formData.skills.length > 0) {
    request.jobSeekerSkillDetails = mapSelectedSkillsToApi(formData.skills)
  }

  // Preferred locations need to be handled from a separate state in UserProfileForm
  // This mapper will need to be updated to accept selectedSkills and preferredLocationIds directly.

  return request;
};

// Helper to map selected skills from UI to API format
export interface JobseekerSkillObj { value : SkillObj ,id: number; name: string; level: skillLevel }

export const mapSelectedSkillsToApi = (selectedSkills: JobseekerSkillObj[]): JobSeekerSkillDetails[] => {
  return selectedSkills.map(s => ({
    skillId: s.id,
    skillLevel: s.level,
  }));
};

// Helper to map preferred locations from UI to API format
export const mapPreferredLocationsToApi = (preferredLocationIds: CityObj[]): JobSeekerPreferredLocationDetails[] => {
  return preferredLocationIds.map(cityObj => ({ cityId: cityObj.cityId , cityName : cityObj.cityName}));
};

const allSkillNames: SkillObj[] = allSkills.skills
export const mapApiToSelectedSkill = (skills : JobSeekerSkillDetails[] ): JobseekerSkillObj[] => {
  const result : JobseekerSkillObj[] = []
  skills.forEach(skill => {
    const mappedSkill = allSkills.skills.find(a => a.skillId == skill.skillId)
    if(mappedSkill){
      result.push({
        value: mappedSkill, // Placeholder for value
        id: mappedSkill.skillId,
        name: mappedSkill.skillName, // Placeholder name
        level: skill.skillLevel
      })
    }
  })
  return result;
}